import * as THREE from "three";
import { Context } from "@/core/context";
import { CommonColor } from "@/core/Parameters";

export class ProtectRadius {
  public ProtectRadiusProject: THREE.Line;
  constructor(context: Context, radius: number) {
    let geo = new THREE.BufferGeometry();
    let positions = new Float32Array(37 * 3);
    for (let index = 0; index <= 36; index++) {
      let angle = (Math.PI * 2 * index) / 36;
      let x = Math.cos(angle) * radius;
      let y = Math.sin(angle) * radius;
      let z = 0;
      positions[index * 3] = x;
      positions[index * 3 + 1] = y;
      positions[index * 3 + 2] = z;
    }
    geo.setAttribute("position", new THREE.BufferAttribute(positions, 3));
    let material = new THREE.LineBasicMaterial({ color: CommonColor.Red });
    this.ProtectRadiusProject = new THREE.Line(geo, material);
    this.ProtectRadiusProject.name = "ProtectRadiusProject";
  }
}
